module.exports = __webpack_public_path__ + "img/cc-apple-pay.0e3e8660.svg";